const main = {
  apiUrl: "https://api-onefootball.vigitalsolutions.com",
  frontendUrl: "https://onefootball.vigitalsolutions.com/frontend",
  videoUrl: "https://video.spovizz.com",
  client: "onefootball_live",
};

const config = {
  ...main,
  testMode: false,
  appName: "Spo|Vizz",
  screenshotsUrl: `${main.apiUrl}/screenshots/[[TEMPLATE]]/[[UUID]]/[[TYPE]].jpg`,
  chatbox: {
    active: false,
  },
  refreshVideoInterval: 10000,
  dashboardTemplatesRefreshInterval: 5000,
  clientBodyClass: "app-opta app-of",
};

export default config;
